import { groupBy, keyBy, map, mapValues } from 'lodash';

import type { Recommender } from '@coursera/event-pulse-types';

import type { SearchSource } from 'bundles/search-common/providers/searchTypes';

const DEFAULT_PAGE_NUMBER = '1';
export function inferPageNumberFromParams(currentPageFromParams: string | string[] | null | undefined): string {
  const pageNumber = Array.isArray(currentPageFromParams) ? currentPageFromParams[0] : currentPageFromParams;
  if (pageNumber === '' || pageNumber === null) return DEFAULT_PAGE_NUMBER; // because Number('' | null) === 0
  const number = Number(pageNumber);
  return isNaN(number) || number < 0 ? DEFAULT_PAGE_NUMBER : String(number);
}
export function inferQueryFromParams(queryFromParams: string | string[] | null | undefined): string {
  return String((Array.isArray(queryFromParams) ? queryFromParams[0] : queryFromParams) || '');
}

export type SearchEventingData = {
  searchIndex: string;
  searchRecommender?: Recommender;
  searchIndexPosition: number;
  page: string;
  searchQuery: string;
  filtersApplied: Record<string, string[]>;
};

export const getSearchEventingData = ({
  source,
  inferredCurrentPageNumber,
  inferredPageNumberFromParams,
  isInfiniteStylePagination,
  activeFilters,
  searchQuery,
}: {
  source?: SearchSource;
  inferredCurrentPageNumber: number;
  inferredPageNumberFromParams: string;
  isInfiniteStylePagination: boolean;
  activeFilters: (string | undefined)[];
  searchQuery: string;
}): SearchEventingData => {
  const groupedFilters = groupBy(activeFilters, (filter) => (typeof filter === 'string' ? filter.split(':')[0] : ''));
  const keyedFilters = keyBy(groupedFilters, (group) =>
    Array.isArray(group) && typeof group[0] === 'string' ? group[0].split(':')[0] : ''
  );
  const filtersApplied = mapValues(keyedFilters, (group) =>
    Array.isArray(group) ? map(group, (filter) => (typeof filter === 'string' ? filter.split(':')[1] : '')) : []
  );
  return {
    searchIndex: source?.indexName || '',
    searchRecommender: source?.recommender
      ? { hash: source.recommender.hash || '', context: source.recommender.context }
      : undefined,
    searchIndexPosition: 1,
    page: isInfiniteStylePagination ? String(inferredCurrentPageNumber) : inferredPageNumberFromParams,
    searchQuery,
    filtersApplied,
  };
};
